import React  from 'react';
import OnBoardingBasicInfoComponent from './onboarding-basic-info.component';
import OnboardRoleSpecificInfoComponent from './onboard-role-specific-info';
import { OnboardAuthorisedSignatoryInfoComponent } from './onboarding-authorized-signatory';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import BusinessBasicInfoComponent from '../business-basic-info.component';
import NPSubscriptionDetailsInfoComponent from '../np-subscriptions-details-info.component';
import BusinessUsersDetailsInfoComponent from './business-users-info-details.component';


export const OnBoardingDetails = ({selectedBusiness,handleInnerbasicFormChange,onBoardDetails,handleFormChange,handleFormGSTItemChange,handleFormAddressItemChange,registeredAddress,gstInfo,authorizedSignatory,handleFormSubmit,handleFormAuthorizedSignatoryItemChange,handleInnerFormChange,selectedSubscriptions,back}: any) => {

  const tabItems=[
    {
      id:1,
      title:'Basic Information',
      component:<BusinessBasicInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      businessDetails={selectedBusiness}
      />,
      isVisible:true
  },
  {
  id: 2,
  title: 'Business Users Details',
  component: (
      <BusinessUsersDetailsInfoComponent
      businessDetails={selectedBusiness}
      />
  ),
  isVisible:true
},
  {
  id: 3,
  title: 'NPSubscriptionsDetails',
  component: (
      <NPSubscriptionDetailsInfoComponent
      businessDetails={selectedBusiness}
      />
  ),
  isVisible:true
},
    {
        id:4,
        title:'Onboard Basic Information',
        component:<OnBoardingBasicInfoComponent 
        subscriptionDetails={onBoardDetails}
        handleFormGSTItemChange={handleFormGSTItemChange}
        handleFormAddressItemChange={handleFormAddressItemChange}
        registeredAddress={registeredAddress}
        gstInfo={gstInfo}
        handleFormChange={handleFormChange}
        handleInnerbasicFormChange={handleInnerbasicFormChange}
        />,
        isVisible:true
    },
    {
      id: 5,
      title: 'Authorised Signatory',
      component: (
          <OnboardAuthorisedSignatoryInfoComponent
          handleFormAuthorizedSignatoryItemChange ={handleFormAuthorizedSignatoryItemChange}
          authorizedSignatory={authorizedSignatory}
          />
      ),
      isVisible:true
  },
  {
    id: 6,
    title: 'Role Specific Information',
    component: (
        <OnboardRoleSpecificInfoComponent
        handleFormChange={handleFormChange}
        subscriptionDetails={onBoardDetails}
        />
    ),
    isVisible:true
},


    
  
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
              onClick={handleFormSubmit}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Save
             </button>
        </div>
       </div>
  )
}
export default OnBoardingDetails;
